import React, {useState, useEffect} from 'react'

import { connect } from 'react-redux';

import {getFileList, importFileData} from 'actions/uploadFile'
import { ToastContainer, toast } from 'react-toastify';

// reactstrap components
import {
  Button,
  Card,
  Label,
  FormGroup,
  Input,
  Table,
  Spinner,
  Row,
  Col,
  UncontrolledTooltip,

} from "reactstrap";


import CheckOPKModal from './CheckOpkModal'
import ImportDetailsModal from './ImportDetailsModal'
import {getFourFifthFileList, importFourFifthFileData,clearError,deleteFourFifthFile} from "../../../../actions/uploadFile";

const FileFourFiveTable = ({UploadFile : {uploadedFile, fourFivesList, error, importLoading,error_msg}, clearError,getFourFifthFileList,deleteFourFifthFile, importFourFifthFileData}) => {
  const [modalConfig, setModalConfig] = useState({
    isShow: false,
    fileID: null,
    getChecker:null
  })

  const [detailsModalConfig, setDetailsModalConfig] = useState({
    isShow: false,
    name: null,
    details: null
  })

  useEffect(() => {
    getFourFifthFileList()
  }, [uploadedFile])
  const [waitingForImport, setWaitingForImport] = useState(false)

    const handleCheckOpk = (e, checkerName, fileID) => {
      e.preventDefault();
      
        setModalConfig(prevState => {
          const newState = {
            ...prevState,
            isShow: true,
            fileID: fileID,
            getChecker: checkerName
          }
          return(newState)
        })

      // let timer1 = setTimeout(() => getFileList(), 3000);

      // this will clear Timeout
      // when component unmount like in willComponentUnmount
      // and show will not change to true
      // return () => {
      //   clearTimeout(timer1);
      // };

    }

    const modalDismiss = () => {
      setModalConfig(prevState => {   
        return({
          ...prevState,
          isShow: false
        })
      })
    }

    const detailsModalDismiss = () => {
      setDetailsModalConfig(prevState => {
        return({
          ...prevState,
          isShow: false
        })
      })
    }

    const showDetails = (fileItem) => {
      console.log("showDetails", fileItem)
      setDetailsModalConfig(prevState => {
        return({
          ...prevState,
          isShow: true,
          name: fileItem.name,
          details: fileItem.import_details
        })
      })
    }

    const handleImport = (e, id) => {
      handleCheckOpk(e, 'getImport', id)
      setWaitingForImport(true)
      importFourFifthFileData(id)
    }
    const deleteImport = (e, id) => {
      deleteFourFifthFile(id)
    }
    useEffect(() => {
      if(!importLoading&&waitingForImport){ 
        modalDismiss()
        setWaitingForImport(false)
        if(!error) {
          toast.info('Zakończono import pliku.', { position: "bottom-right" });
        } else {
          let msg = error_msg ? error_msg : " ";
          toast.error('Importowany plik zawiera błędy! ' + msg, { position: "bottom-right" });
        clearError()
        }
      }
    }, [importLoading])

    return (
        <>
        <ToastContainer />
          <Row>
            <Col className="ml-auto mr-auto" md="11">
              <h2 className="h4 title">
                <small>Lista przesłanych słowników</small>
              </h2>
              {(
                  <Table striped>
                    <thead className='smallerFont'>
                    <tr>
                      <th>Nazwa Pliku</th>
                      <th>Data Przesłania</th>
                      <th className='text-center'>Dane zostały<br/>zaimportowane</th>
                      <th className="text-right">Opcje</th>
                    </tr>
                    </thead>
                    <tbody>
                    {fourFivesList && fourFivesList.map((fileItem, idx) => {
                      const uploadDate = new Date(fileItem.date)
                      return (
                          <tr key={fileItem.id}>

                            <td>{fileItem.name}</td>
                            <td>{`${uploadDate.toLocaleString()}`}</td>
                            <td className='text-center'>
                              {/* <Button
                                  className="btn-link mr-1"
                                  color={fileItem.data_imported ? ("success") : ("danger")}
                                  data-toggle="tooltip"
                                  data-id={fileItem.id}
                                  id={`getCheckFive-${idx}`}
                                  size="sm"
                                  type="button"
                                  style={{cursor: 'default'}}
                                  // disabled={idx!==0}
                                  // disabled = {fileItem.was_checked_five}
                              > */}
                                {fileItem.data_imported ? (
                                    <i className="fas fa-check"></i>
                                ) : (
                                    <i className="fas fa-times"></i>
                                )}
                              {/* </Button> */}
                              {/* <UncontrolledTooltip
                                  delay={0}
                                  placement="top"
                                  target={`getCheckFive-${idx}`}
                              >
                                {fileItem.data_imported ? 
                                  <>Zaimportowano słownik</>
                                 : 
                                  <>Słownik nie został jeszcze zaimportowany</>
                                }
                              </UncontrolledTooltip> */}
                            </td>
                            {/* actions */}
                            <td className="td-actions text-right">
                              <Button
                                  className="btn-link mr-1"
                                  color="danger"
                                  data-toggle="tooltip"
                                  id={`download-${idx}`}
                                  disabled={( fileItem.data_imported)}
                                  size="sm"
                                  type="button"
                                  onClick={(e) => {
                                    deleteImport(e, fileItem.id)
                                  }}
                                  aria-label='Usuń plik'
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                              <UncontrolledTooltip
                                  delay={0}
                                  placement="top"
                                  target={`download-${idx}`}
                              >
                                 Usuń plik
                              </UncontrolledTooltip>
                            <Button
                                  className="btn-link mr-1"
                                  color="info"
                                  data-toggle="tooltip"
                                  id={`importData-${idx}`}
                                  size="sm"
                                  type="button"
                                  disabled={( fileItem.data_imported)}//|| idx!==0}
                                  aria-label='Importuj dane z pliku'
                                  onClick={(e) => {
                                    handleImport(e, fileItem.id)
                                  }}
                              >
                                <i className="fas fa-upload"></i>
                              </Button>
                              <UncontrolledTooltip
                                  delay={0}
                                  placement="top"
                                  target={`importData-${idx}`}
                              >
                                Importuj dane z pliku
                              </UncontrolledTooltip>

                              <Button
                                  className="btn-link mr-1"
                                  color="success"
                                  data-toggle="tooltip"
                                  id={`download-${idx}`}
                                  href={fileItem.file}
                                  size="sm"
                                  type="button"
                                  aria-label="Pobierz plik"
                              >
                                <i className="fas fa-download"></i>
                              </Button>
                              <UncontrolledTooltip
                                  delay={0}
                                  placement="top"
                                  target={`download-${idx}`}
                              >
                                 Pobierz plik
                              </UncontrolledTooltip>
                              <Button
                                  className="btn-link mr-1"
                                  data-toggle="tooltip"
                                  id={`details-${idx}`}
                                  size="sm"
                                  type="button"
                                  aria-label="Szczegóły"
                                  disabled={( !fileItem.data_imported || !fileItem.import_details)}
                                  onClick={() => { showDetails(fileItem) }}
                              >
                                <i className="fas fa-list"></i>
                              </Button>
                              <UncontrolledTooltip
                                  delay={0}
                                  placement="top"
                                  target={`details-${idx}`}
                              >
                                 Zobacz szczeóły importu
                              </UncontrolledTooltip>

                            </td>

                          </tr>
                      )
                    })}
                    </tbody>
                  </Table>
              )}
              
            </Col>
          </Row>
            {modalConfig.isShow && <CheckOPKModal 
            show={modalConfig.isShow} 
            modalDismiss={modalDismiss} 
            fileID={modalConfig.fileID}
            getChecker={modalConfig.getChecker}/> }

            { detailsModalConfig.isShow && <ImportDetailsModal config={detailsModalConfig} modalDismiss={detailsModalDismiss} /> }
        </>
    )
}

const mapStateToProps = (state) => ({
  UploadFile: state.UploadFile,
});

export default connect(mapStateToProps, {getFourFifthFileList,clearError, importFourFifthFileData,deleteFourFifthFile})(FileFourFiveTable)
